import React, { useState, useEffect } from 'react';
import { Box, Stack } from '@mui/material';
import TextInput from '../../../components/ui/textInput';
import Dialog from '../../../components/ui/dialog';
import Alert from '../../../components/ui/alert';
import { callAPI } from '../../../components/utils';
import QRCodeComponent from '../../../components/security/qrCode';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import OtpInput from '../../../components/ui/otpInput';

const EnableOTPForm = ({ open, onClose, onSuccess, otpEnabled }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [otpCode, setOtpCode] = useState(Array(6).fill(''));
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  // const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Creates OTP when otp is not enabled
  useEffect(() => {
    if (!otpEnabled && open) {
      createOTP();
    }
  }, [otpEnabled, open]);

  // Resets values when pop up is closed
  useEffect(() => {
    if (!open) {
      setErrorMessage('');
      // setMessage('');
      setPassword('');
      setOtpCode(Array(6).fill(''));
      setQrCodeUrl('');
      setShowPassword(false);
    }
  }, [open]);

  const createOTP = async () => {
    try {
      const response = await callAPI({
        request: 'createOtpSecret',
        method: 'post',
        onSuccess: (responce) => {
          setQrCodeUrl(responce.data.otpUri);
          // setMessage(
          //   'Scan the QR code with your authenticator app, then enter the OTP.'
          // );
        },
        onError: (error) => {
          throw error;
        },
      });
    } catch (error) {
      console.error('Error creating OTP secret:', error);
      setErrorMessage('Failed to create OTP secret.');
    }
  };

  const enableOTP = async () => {
    if (!password || !otpCode) {
      setErrorMessage('Please enter both your password and OTP.');
      return;
    }

    try {
      const response = await callAPI({
        request: 'enableOtp',
        method: 'post',
        params: { otp: otpCode.join(''), password: password },
        onSuccess: () => {
          onSuccess();
          setQrCodeUrl('');
          // setMessage('OTP has been enabled successfully.');
        },
        onError: (error) => {
          throw error;
        },
      });
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setErrorMessage('Failed to verify OTP: ' + error);
    }
  };

  // Disable OTP with user password
  const disableOTP = async () => {
    if (!password) {
      setErrorMessage('Please enter your password to disable OTP.');
      return;
    }
    try {
      const response = await callAPI({
        request: 'disableOtp',
        method: 'post',
        params: { password },
        onSuccess: () => {
          // setMessage('OTP has been disabled.');
          onSuccess();
        },
        onError: (error) => {
          throw error;
        },
      });
    } catch (error) {
      console.error('Error disabling OTP:', error);
      setErrorMessage(error || 'Failed to disable OTP.');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        otpEnabled
          ? 'Disable Two-Factor Authentication'
          : 'Enable Two-Factor Authentication'
      }
      description={
        otpEnabled
          ? 'Enter your password to disable 2FA.'
          : 'Scan the QR code using your authenticator app, then enter the generated code along with your password.'
      }
      confirmText={otpEnabled ? 'Disable OTP' : 'Verify'}
      onConfirm={otpEnabled ? disableOTP : enableOTP}
      onCancel={onClose}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {otpEnabled ? (
          <Stack spacing={2.5}>
            <TextInput
              label="Password"
              placeholder="Enter your password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              trailingIcon={showPassword ? <Visibility /> : <VisibilityOff />}
              onIconClick={() => setShowPassword(!showPassword)}
              required
            />
            {errorMessage && (
              <Alert message={errorMessage} onClose={() => setErrorMessage('')} />
            )}
          </Stack>
        ) : qrCodeUrl ? (
          <div>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt: -2,
                mb: -1,
              }}
            >
              <QRCodeComponent qrCodeUrl={qrCodeUrl} />
            </Box>
            <Stack spacing={3}>
              <OtpInput
                label="One-time code"
                length={6}
                value={otpCode}
                onChange={(newArray) => setOtpCode(newArray)}
              />
              <TextInput
                label="Password"
                placeholder="Enter your password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                trailingIcon={showPassword ? <Visibility /> : <VisibilityOff />}
                onIconClick={() => setShowPassword(!showPassword)}
                required
              />
              {errorMessage && (
                <Alert message={errorMessage} onClose={() => setErrorMessage('')} />
              )}
            </Stack>

          </div>
        ) : (
          errorMessage && (
            <Alert message={errorMessage} onClose={() => setErrorMessage('')} />
          )
        )}
      </Box>
    </Dialog>
  );
};

export default EnableOTPForm;
